import { render, staticRenderFns } from "./DetailReferenceAccounts.vue?vue&type=template&id=65339dff&scoped=true&"
import script from "./DetailReferenceAccounts.vue?vue&type=script&lang=js&"
export * from "./DetailReferenceAccounts.vue?vue&type=script&lang=js&"
import style0 from "./DetailReferenceAccounts.vue?vue&type=style&index=0&id=65339dff&scoped=true&lang=css&"
import style1 from "./DetailReferenceAccounts.vue?vue&type=style&index=1&id=65339dff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65339dff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSimpleTable,VTooltip})
